import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { AuditService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfFrontAuditVm,
  FrontAuditDto,
  FrontAuditVm,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';

@Component({
    selector: 'app-front-audits',
    templateUrl: './front-audits.component.html',
    standalone: false
})
export class FrontAuditsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'audits';
  modelWithPagination$: Observable<FrontAuditVm>;
  items$: Observable<Array<FrontAuditDto>>;

  showAuditDetails: boolean = false;
  auditDetailsModel: FrontAuditDto;
  //#endregion

  constructor(protected currentService: AuditService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showRefreshBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.tableConfig.pageSizes = [30, 40, 50, 60, 80, 100];
      this.pageConfig.title = 'common.frontAudits';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Details_key) this.onDetail({}, false);
    }
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: 'Document.UserInfo.UserName',
        hasSearch: true,
        type: 'auditText',
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}className`,
        name: 'Document.Data.ClassName',
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}comments`,
        name: 'Document.Data.Comments',
        noSorting: true,
      },
      {
        title: this.localizer.startDate,
        name: 'Document.StartDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.endDate,
        name: 'Document.EndDate',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  setDefaultTableSort() {
    try {
      this.sortObject.push({ columnName: 'Document.StartDate', sort: 1 });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  getPaginationApi(): Observable<CustomResultOfFrontAuditVm> {
    return this.currentService.auditGetFrontAuditWithPagination({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  onDetail(model: FrontAuditDto, setFiltersAndUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          JSON.stringify(model)
      );
    }
    this.showAuditDetails = true;
    this.auditDetailsModel = model;
  }

  onCloseDetail(event) {
    this.showAuditDetails = false;
  }
}
